var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.75H0V0H14V1.75H12.25V3.5C12.25 4.91313 11.536 6.05063 10.6365 6.97988C10.0214 7.61513 9.27325 8.2005 8.51462 8.75C9.27325 9.2995 10.0214 9.88487 10.6365 10.5201C11.536 11.4494 12.25 12.5869 12.25 14V15.75H14V17.5H0V15.75H1.75V14C1.75 12.5869 2.464 11.4494 3.3635 10.5201C3.97862 9.88487 4.72675 9.2995 5.48537 8.75C4.72675 8.2005 3.97862 7.61513 3.3635 6.97988C2.464 6.05063 1.75 4.91313 1.75 3.5V1.75ZM3.5 1.75V3.5C3.5 4.09937 3.7275 4.66813 4.17462 5.25H9.82537C10.2716 4.66813 10.5 4.09937 10.5 3.5V1.75H3.5ZM7 9.81925C6.08563 10.465 5.257 11.0801 4.62088 11.7372C4.46253 11.8996 4.31354 12.0708 4.17462 12.25H9.82537C9.68644 12.0708 9.53745 11.8996 9.37912 11.7372C8.743 11.0801 7.91437 10.465 7 9.81925Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/duration-icon.c96361090ca3e47b31fbb98f769ec97a.svg";
export { ForwardRef as ReactComponent };